/* eslint-disable */
import React from 'react';
import { TweenMax, TimelineMax, Quart, Expo, Back } from 'gsap/all';
import cls from 'classnames';
import PropTypes from 'prop-types';
import isString from '@dcode/is/string/string';
import FiatBrand from '~/components/FiatBrand/FiatBrand';
import Img from '~/components/Elements/Img';
import css from './Thumbnail.scss';

const classes = {
	root: css.thumbnail,
	poster: css.thumbnailPoster,
	posterAspect: css.thumbnailPosterAspect,
	posterRatio: css.thumbnailPosterRatio,
	posterImage: css.thumbnailPosterImage,
	posterIcon: css.thumbnailPosterIcon,
	posterIconX: css.thumbnailPosterIconX,
	posterIconY: css.thumbnailPosterIconY,
	posterCaption: css.thumbnailPosterCaption,
	posterCaptionIcon: css.thumbnailPosterCaptionIcon,
	posterCaptionIconBrand: css.thumbnailPosterCaptionIconBrand,
	posterCaptionText: css.thumbnailPosterCaptionText,
	isVisible: css.isVisible,
	isDisabled: css.isDisabled,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	caption: PropTypes.string,
	// img: PropTypes.exact(Img.propTypes),
	disabled: PropTypes.bool,
	visible: PropTypes.bool,
	onTransitionOutComplete: PropTypes.func,
};

const defaultProps = {
	className: '',
	classes,
	caption: '',
	img: undefined,
	disabled: false,
	visible: true,
	onTransitionOutComplete: Function.prototype,
};

export const Thumbnail = React.forwardRef(({
	className,
	classes,
	img,
	caption,
	visible,
	disabled,
	onTransitionOutComplete,
	...props
}, ref) => {
	const rootRef = React.useRef();
	const posterIconRef = React.useRef();
	const posterIconXRef = React.useRef();
	const posterIconYRef = React.useRef();

	React.useImperativeHandle(ref, () => ({
		root: rootRef.current,
		icon: posterIconRef.current,
		iconX: posterIconXRef.current,
		iconY: posterIconYRef.current,
	}));

	return (
		<figure
			{...props}
			ref={rootRef}
			className={cls(classes.root, className, {
				[classes.isDisabled]: disabled,
			})}>
			<div
				className={cls(classes.poster)}>
				<div className={cls(classes.posterRatio)}>
					<Img className={cls(classes.posterImage)} {...img} />
				</div>
				<i className={cls(classes.posterIcon)} ref={posterIconRef} aria-hidden={true}>
					<span className={cls(classes.posterIconX)} ref={posterIconXRef} />
					<span className={cls(classes.posterIconY)} ref={posterIconYRef} />
				</i>
				<div className={cls(classes.posterCaption)}>
					<div className={cls(classes.posterCaptionIcon)}>
						<FiatBrand
							className={cls(classes.posterCaptionIconBrand)}
							stripes={'#fff'}
							height={12.4}
						/>
					</div>
					<svg className={cls(classes.posterCaptionText)} viewBox="0 0 160 79">
						<text x="0" y="0"
							dangerouslySetInnerHTML={{
								__html: isString(caption) ? caption.split(/\<br\s{0,}?\/?\>/gi).map((text) =>
									`<tspan x="0" dy="1em">${text}</tspan>`
								).join('') : '&nbsp;'
							}}
						/>
					</svg>
				</div>
			</div>
		</figure>
	);
});

Thumbnail.displayName = 'Thumbnail';
Thumbnail.propTypes = propTypes;
Thumbnail.defaultProps = defaultProps;
export default Thumbnail;
